import { Route, NavigationGuardNext } from 'vue-router';

/**
 * Guard that sets the use-simple-header meta tag for routes that use the simple header, i.e. job-post
 */
function setSimpleHeaderGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  let existingMetaTag = document.querySelector('meta[name="use-simple-header"]');

  if (!existingMetaTag) {
    existingMetaTag = document.createElement('meta');
    existingMetaTag.setAttribute('name', 'use-simple-header');
    existingMetaTag.setAttribute('content', 'true');
    document.head.appendChild(existingMetaTag);
  } else {
    existingMetaTag.setAttribute('content', 'true');
  }

  // Always proceed to the next guard
  next();
}

export default setSimpleHeaderGuard;
